/* tslint:disable */
import {
  PropertyUnits,
  InspectionFile
} from '../index';

declare var Object: any;
export interface InspectionRoomInterface {
  "id"?: number;
  "property_unit_id": number;
  "room_name": string;
  "display_order"?: number;
  "is_active"?: boolean;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  propertyUnit?: PropertyUnits;
  inspectionFiles?: InspectionFile[];
}

export class InspectionRoom implements InspectionRoomInterface {
  "id": number;
  "property_unit_id": number;
  "room_name": string;
  "display_order": number;
  "is_active": boolean;
  "createdAt": Date;
  "updatedAt": Date;
  propertyUnit: PropertyUnits;
  inspectionFiles: InspectionFile[];
  constructor(data?: InspectionRoomInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InspectionRoom`.
   */
  public static getModelName() {
    return "InspectionRoom";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InspectionRoom for dynamic purposes.
  **/
  public static factory(data: InspectionRoomInterface): InspectionRoom{
    return new InspectionRoom(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InspectionRoom',
      plural: 'InspectionRooms',
      path: 'InspectionRooms',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "room_name": {
          name: 'room_name',
          type: 'string'
        },
        "display_order": {
          name: 'display_order',
          type: 'number',
          default: 0
        },
        "is_active": {
          name: 'is_active',
          type: 'boolean',
          default: true
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        propertyUnit: {
          name: 'propertyUnit',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        inspectionFiles: {
          name: 'inspectionFiles',
          type: 'InspectionFile[]',
          model: 'InspectionFile',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'inspection_room_id'
        },
      }
    }
  }
}
